import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { SectionSidebarNav, type SectionSidebarNavLinkItem } from "@/components/SectionSidebarNav";
import { Alert } from "@/components/ui/Alert";
import { Spinner } from "@/components/ui/Spinner";
import { useCurrentUser } from "@/lib/auth";
import { canViewHref } from "@/lib/acl";

const NAV: SectionSidebarNavLinkItem[] = [
  { key: "uebersicht", label: "Übersicht", href: "/veranstaltungen", end: true },
  {
    key: "messe",
    label: "Veranstaltungen Messe",
    href: "/veranstaltungen/messe",
    badgeKeys: ["veranstaltungen-ungelesen"],
  },
  { key: "meros", label: "Meros", href: "/veranstaltungen/meros" },
];

export function VeranstaltungenLayout() {
  const { user, loading, error } = useCurrentUser();
  const location = useLocation();
  const groups = (user?.groups as string[] | undefined) ?? [];
  const [vollenZugang, setVollenZugang] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user) {
      setVollenZugang(null);
      return;
    }
    let cancelled = false;
    void canViewHref("/veranstaltungen.html", groups).then((ok) => {
      if (!cancelled) setVollenZugang(ok);
    });
    return () => {
      cancelled = true;
    };
  }, [groups, user]);

  if (loading || (user && vollenZugang === null)) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-label-secondary">
        <div className="flex items-center gap-2 text-sm">
          <Spinner />
          <span>Berechtigung wird geprüft …</span>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="mx-auto max-w-md py-10">
        <Alert variant="error" title="Sitzung konnte nicht geladen werden">
          {error || "Bitte erneut anmelden."}
        </Alert>
      </div>
    );
  }

  const nurMeros = !vollenZugang && user.meros_seite === true;
  if (!vollenZugang && !nurMeros) {
    return (
      <div className="mx-auto max-w-md py-10">
        <Alert variant="error" title="Keine Berechtigung">
          Diese Seite ist für deine Benutzergruppe nicht freigeschaltet.
        </Alert>
      </div>
    );
  }

  const path = location.pathname.replace(/\/$/, "");
  const fremdeSeite = path.endsWith("/veranstaltungen") || path.includes("/veranstaltungen/messe");

  return (
    <div className="eh-bestellwesen-page-shell">
      <SectionSidebarNav items={nurMeros ? NAV.filter((item) => item.key === "meros") : NAV} ariaLabel="Veranstaltungen" />
      <div className="eh-project-page-main">
        {nurMeros && fremdeSeite ? <Navigate to="/veranstaltungen/meros" replace /> : <Outlet />}
      </div>
    </div>
  );
}
